import InfoIcon from '@service-victoria/component-library/components/Icons/Info';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Routes } from 'utils/constants';

import * as Styled from './styled';

interface BusinessDetailsSubContentProps {
  locationName: string;
  areaName?: string;
}

const BusinessDetailsSubContent: React.FC<BusinessDetailsSubContentProps> = ({
  locationName,
  areaName
}) => {
  const history = useHistory();
  const location = useLocation();

  const toggleLocation = () =>
    history.push(
      location.pathname === Routes.RegisteredLocation ? Routes.CheckIn : Routes.RegisteredLocation
    );

  return (
    <Styled.Wrapper>
      <Styled.Content>
        <Styled.DetailLine data-testid='BusinessDetailLocation'>
          Location: {locationName}
        </Styled.DetailLine>
        {areaName && (
          <Styled.DetailLine data-testid='BusinessDetailArea'>Area: {areaName}</Styled.DetailLine>
        )}
      </Styled.Content>
      <Styled.Action onClick={toggleLocation} data-testid='AdminAreaIconButton'>
        <InfoIcon />
      </Styled.Action>
    </Styled.Wrapper>
  );
};

export default BusinessDetailsSubContent;
